<template>
    <v-container class="content-container">
        <v-row>
            <v-col>

                <div v-if="trainingStore.VprasanjeLoaded">

                    <!-- Heading -->
                    <div class="contract-heading d-flex justify-space-between align-center">

                        <!-- Heading text -->
                        <div class="contract-heading__heading ma-0">
                            {{ trainingStore.CurrentSklop!.Name }}
                        </div>

                        <!-- Steps -->
                        <div class="contract-heading__step">
                            <span class="tag tag--white">
                                {{ trainingStore.CurrentVprasanjeId + 1 }}/{{ trainingStore.CurrentSklop!.StVprasanj }}
                                korakov
                            </span>
                        </div>
                    </div>

                    <!-- Content -->
                    <div class="px-8">

                        <!-- Step subject -->
                        <div class="section-heading">
                            {{ trainingStore.currentVprasanje.Subject }}
                        </div>

                        <!-- Step content -->
                        <div v-html="trainingStore.currentVprasanje.Content"></div>

                    </div>

                    <!-- Answer -->
                    <div class="card card--default mt-8 training__answer">
                        <TrainingAnswer v-for="odgovor in trainingStore.currentVprasanje.Odgovori" :odgovor="odgovor">
                        </TrainingAnswer>
                    </div>

                    <!-- Answer validation -->
                    <div class="v-input--error">
                        <div class="v-input__details"
                            v-if="trainingStore.currentVprasanje.ValidationError != undefined">
                            <div class="v-messages">
                                <div class="v-messages__message">
                                    {{ trainingStore.currentVprasanje.ValidationError }}
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Btns -->
                    <div class="d-flex justify-space-between mt-8 mb-14">
                        <v-btn class="btn btn--default-fill" v-if="trainingStore.CurrentVprasanjeId == 0"
                            @click="ToSeznam()"
                           >Prekliči</v-btn>
                        <v-btn class="btn btn--default-fill" v-if="trainingStore.CurrentVprasanjeId > 0"
                            @click="trainingStore.prevQuestion()">Nazaj</v-btn>

                        <div class="d-flex ga-4 ml-auto">
                            <v-btn class="btn btn--default-fill" @click="trainingStore.saveTraining()">Shrani in
                                zapri</v-btn>
                            <v-btn class="btn btn--primary-fill"
                                v-if="trainingStore.CurrentVprasanjeId < trainingStore.CurrentSklop!.StVprasanj - 1"
                                @click="trainingStore.nextQuestion()">Naprej</v-btn>
                            <v-btn class="btn btn--primary-fill"
                                v-if="trainingStore.CurrentVprasanjeId == trainingStore.CurrentSklop!.StVprasanj - 1"
                                @click="trainingStore.complete()">Zaključi</v-btn>
                        </div>
                    </div>

                </div>

            </v-col>
        </v-row>
    </v-container>
</template>

<script setup lang="ts">
    import router from "@app/router";
    import TrainingAnswer from "@views/user-center-trainings/training-answer.vue";
    import { useTrainingStore } from "@/app/store/app/user-center-trainings/store";

    const trainingStore = useTrainingStore();

    const props = defineProps({
        id: String
    });

    trainingStore.VprasanjeLoaded = false;

    if (trainingStore.Sklopi.length == 0) {
        router.push({ name: "trainings" })
    } else {
        if (props.id != undefined) {
            trainingStore.loadSpecificTraining(parseInt(props.id!));
            trainingStore.CurrentVprasanjeId = 0;
        } else {
            router.push({ name: "trainings" })
        }
    };

    function back() {
        router.push({ name: "trainings" })
    };

    function ToSeznam() {
        router.push({ name: "trainings" })
    };
</script>
